import React from 'react'

import GlobalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { Notification } from '../components/Notification/Notification'
import { ReportsApprovalTypes } from '../types/ReportsApproval'
import { DateCheckResponseTypes, SendCheckResponseTypes } from '../types/ApiResponses'

const requestCommon = {
    credentials: 'same-origin',
    cache: 'no-cache'
} as RequestInit

const jsonHeaders = {
    'Content-Type': 'application/json'
} as HeadersInit

export enum METHODS {
    GET = 'GET',
    POST = 'POST',
    DELETE = 'DELETE',
    PUT = 'PUT'
}
const PREFIX_URL_REPORT = '/services/plugin-reports-approval/api/'
const PREFIX_URL_LIVE = '/rest/'

// FETCHERS
async function fetchApi<T>(url: string, method = METHODS.GET, body?: string | undefined): Promise<T> {
    return await fetch(PREFIX_URL_REPORT + url, { ...requestCommon, headers: jsonHeaders, method, body }).then(
        async response => {
            // reading the stream only once.
            const finalRes = await response.json()

            if (!response.ok) {
                if (finalRes.then) {
                    finalRes.then(errorText => {
                        throw errorText
                    })
                } else {
                    throw new Error(finalRes.error)
                }
            }

            return finalRes
        }
    )
}

export async function getLiveApi<T>(url: string): Promise<T> {
    return await fetch(PREFIX_URL_LIVE + url, { ...requestCommon, headers: jsonHeaders, method: METHODS.GET }).then(
        async response => {
            // reading the stream only one time..
            const finalRes = await response.json()

            if (!response.ok) {
                finalRes.then(errorText => {
                    throw errorText
                })
            }

            return finalRes
        }
    )
}

export async function getApprovalSchedulersList(): Promise<ReportsApprovalTypes[]> {
    try {
        const res = await fetchApi<ReportsApprovalTypes[]>(`approvalSchedulersList`)
        if (!res) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to get the approval schedulers list: ')}>
                    {'unknown error'}
                </Notification>,
                20
            )
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get the approval schedulers list: ')}>{error}</Notification>,
            20
        )

        console.error(error)
    }
}

export async function updateSchedulerDataCheck(schedulerId: number): Promise<DateCheckResponseTypes> {
    try {
        const res = await fetchApi<DateCheckResponseTypes>(
            `approvalSchedulersList/checkData/${schedulerId}`,
            METHODS.POST
        )
        if (!res) {
            GlobalNotification.error(
                <Notification title={i18n('Error when trying to update scheduler date check: ')}>
                    {'unknown error'}
                </Notification>,
                20
            )
        }

        return res.checkData
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error when trying to update scheduler date check: ')}>{error}</Notification>,
            20
        )

        console.error(error)
    }
}

export async function updateSchedulerSendCheck(schedulerId: number): Promise<SendCheckResponseTypes> {
    try {
        const res = await fetchApi<SendCheckResponseTypes>(
            `approvalSchedulersList/sendReport/${schedulerId}`,
            METHODS.POST
        )
        if (!res) {
            GlobalNotification.error(
                <Notification title={i18n('Error when trying to send report: ')}>{'unknown error'}</Notification>,
                20
            )
        }

        return res.sendData
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error when trying to send report: ')}>{error}</Notification>,
            20
        )

        console.error(error)
    }
}

export async function getServerLocalTimeZone(): Promise<any> {
    try {
        const res = await fetchApi<any>(`approvalSettings/serverLocalTimeZone`)

        return res.timeZone
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get the server local time. Error: ')}>{error}</Notification>,
            20
        )

        return console.error(error)
    }
}

export async function getDashboardsFromLive(): Promise<any> {
    try {
        const res = await getLiveApi<any>(`dashboard`)
        if (!res) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to get the dashboards list: ')}>
                    {'unknown error'}
                </Notification>,
                20
            )
        }

        return res.data
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get the dashboards list: ')}>{error}</Notification>,
            20
        )

        console.error(error)
    }
}
